<template>
    <div>   
        <van-tabbar v-model="activeValue" class="footer" @change="getshift()">
            <van-tabbar-item to="/choosePavilion">
                <div class="footer-wrap">
                    <img class="footer-wrap-img" src="~statics/mobileShouye/pavilion.png" alt="">
                </div>
                <span class="footer-wrap-title">{{$t("header").pavilion}}</span>
            </van-tabbar-item>
            <van-tabbar-item to="/mobileExhibitors"> 
                <div class="footer-wrap">
                    <img class="footer-wrap-img" src="~statics/mobileShouye/exhibit.png" alt="">
                </div>
                <span class="footer-wrap-title">{{$t("header").exhibition}}</span>
            </van-tabbar-item>
            <van-tabbar-item to="/mobileExhibition"> 
                <div class="footer-wrap">
                    <img class="footer-wrap-img" src="~statics/mobileShouye/homepage.png" alt="">
                </div>
                <span class="footer-wrap-title">{{$t("header").home}}</span>
            </van-tabbar-item>
            <van-tabbar-item to="/mobileplateformInfo">
                 <div class="footer-wrap">
                    <img class="footer-wrap-img" src="~statics/mobileShouye/review.png" alt="">
                </div>
                <span class="footer-wrap-title">{{$t("header").info}}</span>
            </van-tabbar-item>
            <van-tabbar-item to="/home"> 
                <div class="footer-wrap">
                    <img class="footer-wrap-img" src="~statics/mobileShouye/myCenter.png" alt="">
                </div>
                <span class="footer-wrap-title">{{$t("header").my}}</span>
            </van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>

export default {
    props: {
        
    },
    watch: {
        $route: {
            handler(route) {
                // console.log(route)
                if(route.path == "/choosePavilion"){
                    this.activeValue = 0
                }
                if(route.path == "/mobileExhibitors"){
                    this.activeValue = 1
                }
                if(route.path == "/mobileExhibition"){
                    this.activeValue = 2
                }
                if(route.path == "/mobileplateformInfo"){
                    this.activeValue = 3
                }
                if(route.path == "/home"){
                    this.activeValue = 4
                }
            },
		    immediate: true,
        },
        
    },
    data(){
        return{
            activeValue: null,
        }
    },
    created() {

    },
    methods: {
        getshift(){
            // alert(this.activeValue)
            // this.activeValue = this.activeValue
        },
        hanleReview(){
            this.$notify({ 
                type: 'danger', 
                message: this.$t('header').template_tip ,
                background: '#3a3c3f'
            })
        }
    },
}
</script>

<style lang="scss" scoped>
/deep/ .container{
    padding: unset;
}
/deep/ .mu-bottom-nav{
    width:7.5rem;
    height: 1.1rem
}
/deep/ .van-tabbar-item--active{
    color: unset;
    background: unset;
     .van-tabbar-item__text{
        display: flex;
        flex-direction: column;
        justify-content: center;
        // align-items: center;
        // margin-bottom: .91rem;
        .footer-wrap{
            border-radius: 50%;
            width: .8rem;
            height: .8rem;
            background-color: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            top: -0.1rem;
            // bottom: 1.2rem;
            .footer-wrap-img{
                width: .5rem;
                height: .5rem;
                opacity: 1;
            }
        }
        .footer-wrap-title{
            // line-height: .34rem;
            color: #ffffff;
            opacity: 1;
            position: absolute;
            bottom: .1rem;
            // height: .74rem;
        }
    }
}
 /deep/ .van-tabbar-item__text{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // margin-bottom: .68rem;
    .footer-wrap{
        border-radius: 50%;
        width: .56rem;
        height: .56rem;
        transition: all 0.6s ease-in-out;
        background-color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        .footer-wrap-img{
            width: .4rem;
            height: .4rem;
            opacity: 1;
        }
    }
    .footer-wrap-title{
        line-height: .34rem;
        color: #ffffff;
        opacity: 1;
    }
}
.footer{
    width: 100%;
    height: 1.1rem;
    opacity: 0.8;
    background: #194b96;
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/mobileExhibition/components/Footers.vue